import React from 'react';

export default function Footer () {
  return (
    <footer>
      <p className="copy">&copy;Keith Charles 2023</p>
    </footer>
  )
}